import { APIFactory } from '../api/api.factory'
const SnapShotAPI = APIFactory.get('snapshots');


export default {
    //get snapshots
    async getAllSnapshots(erid, sectionTypeId) {

        const { data } = await SnapShotAPI.get(erid)
        //remove first created audit entry as it does not need to be returned to view per PSI       
        //data.pop()

        return data;
    }
}